import { render, staticRenderFns } from "./transactionVersion2.vue?vue&type=template&id=236e7294&scoped=true&"
import script from "./transactionVersion2.vue?vue&type=script&lang=js&"
export * from "./transactionVersion2.vue?vue&type=script&lang=js&"
import style0 from "./transactionVersion2.vue?vue&type=style&index=0&id=236e7294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e7294",
  null
  
)

export default component.exports